import React from 'react';
import type { HTMLAttributes, ElementRef, Ref, ReactNode } from 'react';

import type { StyleProps } from '@backyard-ui/styles';

import { useCardContext } from './Card.context';

import styles from './Card.styles';

export interface CardBodyProps
  extends StyleProps<HTMLAttributes<HTMLDivElement>> {
  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * The children elements
   */
  children: ReactNode;
}

const Body = React.forwardRef<ElementRef<'div'>, CardBodyProps>(
  (props, ref) => {
    const { UNSAFE_className, UNSAFE_style, ...rest } = props;
    const { size } = useCardContext();

    return (
      <div
        className={styles({
          size,
        }).body({
          className: UNSAFE_className,
        })}
        style={UNSAFE_style}
        ref={ref}
        {...rest}
      />
    );
  }
);

Body.displayName = '@backyard-ui/core/CardBody';

export default Body;
